import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAuthenticated } from '../auth';
import { OdometerReading } from '../types/odometer';
import { getOdometerReading } from '../util/odometer';

export interface UseOdometerReadingQueryOptions {
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
}

export const getOdometerReadingQueryKey = (thingId: string): (string | Record<string, unknown>)[] => [
  'odometer-reading',
  { thingId },
];

export const useOdometerReadingQuery = (
  thingId: string | undefined,
  options?: UseOdometerReadingQueryOptions,
): UseQueryResult<OdometerReading | null> => {
  const { restClient } = useAuthenticated();

  const queryKey = getOdometerReadingQueryKey(thingId ?? '');

  const queryFn = useCallback(
    () => getOdometerReading(restClient, thingId ?? ''),
    [restClient, thingId],
  );

  return useQuery({
    queryKey,
    queryFn,
    enabled: (options?.enabled ?? true) && Boolean(thingId),
    staleTime: options?.staleTime ?? 1000 * 60,
    gcTime: options?.gcTime ?? 1000 * 60 * 60,
  });
};
